import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, ArrowRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';

export default function ViewCartBanner() {
  const { totalItems, totalPrice } = useCart();
  const { pathname } = useLocation();

  // Hide on cart, checkout, and admin pages
  const hidden = totalItems === 0 || pathname === '/cart' || pathname === '/checkout' || pathname.startsWith('/admin');

  return (
    <AnimatePresence>
      {!hidden && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 20, stiffness: 300 }}
          className="fixed bottom-0 left-0 right-0 z-50 lg:hidden p-3"
        >
          <Link
            to="/cart"
            className="flex items-center justify-between w-full px-5 py-3.5 bg-emerald-600 text-white rounded-2xl shadow-xl shadow-emerald-600/30"
          >
            <div className="flex items-center gap-3">
              <div className="relative">
                <ShoppingBag size={20} />
                <span className="absolute -top-2 -right-2 bg-white text-emerald-700 text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center">
                  {totalItems}
                </span>
              </div>
              <div className="text-left">
                <p className="text-sm font-bold">{totalItems} {totalItems === 1 ? 'item' : 'items'}</p>
                <p className="text-xs text-emerald-100">₹{totalPrice.toLocaleString('en-IN')}</p>
              </div>
            </div>
            <div className="flex items-center gap-1 text-sm font-bold">
              View Cart <ArrowRight size={16} />
            </div>
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
